import React from 'react';

interface Props {
  cols: number
  gap?: number
}

export const FormGrid: React.FC<Props> = (props) => {
  const { cols, gap = 32 } = props;
  const templateColumns = new Array(cols).fill('1fr').join(' ');

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: templateColumns,
    columnGap: gap,
  };
  
  return (
    React.createElement('grid', {'is': '', style: gridStyle},
      props.children
    )
  );
};
